import {ThemeEnum} from "../../../core/enums/theme-enum";

export enum DateLevelEnum {
  YEAR,
  MONTH,
  DAY
}

export const DateLevelFormat: Record<DateLevelEnum, string> = {
  [DateLevelEnum.YEAR]: "yyyy",
  [DateLevelEnum.MONTH]: "MM/yyyy",
  [DateLevelEnum.DAY]: "dd/MM/yyyy"
}

export const DateLevelZoom: Record<DateLevelEnum, any> = {
  [DateLevelEnum.YEAR]: {zoomLevel: "decade", maxZoomLevel: "decade"},
  [DateLevelEnum.MONTH]: {zoomLevel: "year", maxZoomLevel: "year"},
  [DateLevelEnum.DAY]: {zoomLevel: "month", maxZoomLevel: "month"}
}
